import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { EventProfiles, Shared } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    params: {} as { id: string },
    request: {} as EventProfiles.Post.LegacyEncoderVideoSignedUrl,
    response: {} as Shared.Library.SignedUrl,
    url: `${CENTRAL_API_V3}/customers/@customerId/eventprofiles/@id/upload`,
  },
};

export const id = {};
